module.exports = __webpack_public_path__ + "static/media/S1-20-Cretaur-K-cod20.ff977de3.png";